import { render, staticRenderFns } from "./audit.vue?vue&type=template&id=1a62126d"
import script from "./audit.vue?vue&type=script&lang=js"
export * from "./audit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a62126d')) {
      api.createRecord('1a62126d', component.options)
    } else {
      api.reload('1a62126d', component.options)
    }
    module.hot.accept("./audit.vue?vue&type=template&id=1a62126d", function () {
      api.rerender('1a62126d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/audit/sku/packageCSG/audit.vue"
export default component.exports